import { AppColors, AppPalette, CustomPalette } from "@bpipartners/webui";

export const appPalette: AppPalette = {
  primary: {
    "0": "#000000",
    "5": "#0b0813",
    "10": "#161027",
    "20": "#2d1f4d",
    "25": "#382761",
    "30": "#432f74",
    "35": "#4e3787",
    "40": "#5a3e9a",
    "50": "#704EC1",
    "60": "#8d71cd",
    "70": "#a995da",
    "80": "#c6b8e6",
    "90": "#e2dcf3",
    "95": "#f1edf9",
    "98": "#f9f8fd",
    "99": "#fcfbfe",
    "100": "#FFFFFF",
  },
  tertiary: {
    "0": "#000000",
    "5": "#0c0d0a",
    "10": "#181b14",
    "20": "#313628",
    "25": "#3d4333",
    "30": "#49503d",
    "35": "#555e47",
    "40": "#626b51",
    "50": "#7A8665",
    "60": "#959e84",
    "70": "#afb6a3",
    "80": "#cacfc1",
    "90": "#e4e7e0",
    "95": "#f2f3f0",
    "98": "#fafaf9",
    "99": "#fcfdfc",
    "100": "#FFFFFF",
  },
  secondary: {
    "0": "#000000",
    "5": "#12160a",
    "10": "#232c14",
    "20": "#465728",
    "25": "#586d33",
    "30": "#69833d",
    "35": "#7a9947",
    "40": "#8cae51",
    "50": "#AFDA65",
    "60": "#bfe184",
    "70": "#cfe9a3",
    "80": "#dff0c1",
    "90": "#eff8e0",
    "95": "#f7fbf0",
    "98": "#fcfef9",
    "99": "#fdfefc",
    "100": "#FFFFFF",
  },
  error: {
    "0": "#000000",
    "5": "#2D0001",
    "10": "#410002",
    "20": "#690005",
    "25": "#7E0007",
    "30": "#93000A",
    "35": "#A80710",
    "40": "#BA1A1A",
    "50": "#DE3730",
    "60": "#FF5449",
    "70": "#FF897D",
    "80": "#FFB4AB",
    "90": "#FFDAD6",
    "95": "#FFEDEA",
    "98": "#FFF8F7",
    "99": "#FFFBFF",
    "100": "#FFFFFF",
  },
  neutral: {
    "0": "#000000",
    "5": "#10110D",
    "10": "#1B1C18",
    "20": "#30312C",
    "25": "#3B3C37",
    "30": "#464742",
    "35": "#52534D",
    "40": "#5E5F59",
    "50": "#777771",
    "60": "#91918B",
    "70": "#ACACA5",
    "80": "#C7C7C0",
    "90": "#E3E3DB",
    "95": "#F2F1E9",
    "98": "#FBFAF2",
    "99": "#FEFCF5",
    "100": "#FFFFFF",
  },
  neutralVariant: {
    "0": "#000000",
    "5": "#0F1209",
    "10": "#191D14",
    "20": "#2E3228",
    "25": "#393D32",
    "30": "#44483D",
    "35": "#505448",
    "40": "#5C6054",
    "50": "#75796C",
    "60": "#8F9285",
    "70": "#A9AD9F",
    "80": "#C5C8B9",
    "90": "#E1E4D5",
    "95": "#EFF2E3",
    "98": "#F8FBEB",
    "99": "#FBFEEE",
    "100": "#FFFFFF",
  },
};

export const appColors: AppColors = {
  primary: appPalette.primary[50],
  onPrimary: appPalette.primary[100],
  primaryContainer: appPalette.primary[90],
  onPrimaryContainer: appPalette.primary[10],
  primaryFixed: appPalette.primary[90],
  onPrimaryFixed: appPalette.primary[10],
  primaryFixedDim: appPalette.primary[80],
  onPrimaryFixedVariant: appPalette.primary[30],
  secondary: appPalette.secondary[50], // was secondary 40
  onSecondary: appPalette.secondary[100],
  secondaryContainer: appPalette.secondary[90],
  onSecondaryContainer: appPalette.secondary[10],
  secondaryFixed: appPalette.secondary[90],
  onSecondaryFixed: appPalette.secondary[10],
  secondaryFixedDim: appPalette.secondary[80],
  onSecondaryFixedVariant: appPalette.secondary[30],
  tertiary: appPalette.tertiary[50], // was "#386662"
  onTertiary: appPalette.tertiary[100],
  tertiaryContainer: appPalette.tertiary[90], //was "#BCECE7"
  onTertiaryContainer: appPalette.tertiary[10],
  tertiaryFixed: appPalette.tertiary[90], //was "#BCECE7"
  onTertiaryFixed: appPalette.tertiary[10],
  tertiaryFixedDim: appPalette.tertiary[80], //was "#A0D0CB"
  onTertiaryFixedVariant: appPalette.tertiary[30], // was  "#1F4E4B"
  error: appPalette.error[40],
  onError: appPalette.error[100],
  errorContainer: appPalette.error[90],
  onErrorContainer: appPalette.error[10],
  outline: appPalette.neutral[50],
  background: appPalette.neutral["100"],
  onBackground: appPalette.neutral[10],
  surface: appPalette.neutral["98"],
  onSurface: appPalette.neutral[10],
  surfaceVariant: appPalette.neutralVariant[90],
  onSurfaceVariant: appPalette.neutralVariant[30],
  inverseSurface: appPalette.neutral[20],
  inverseOnSurface: appPalette.neutral[95],
  inversePrimary: appPalette.primary[80],
  shadow: appPalette.neutral[0],
  surfaceTint: appPalette.primary[40],
  outlineVariant: appPalette.neutralVariant[80],
  scrim: appPalette.neutralVariant[0],
  surfaceContainerHighest: appPalette.neutral[90],
  surfaceContainerHigh: appPalette.neutral["95"], //was "#E9E8E1"
  surfaceContainer: appPalette.neutral["98"], //"#EFEEE6"
  surfaceContainerLow: appPalette.neutral["99"], // was  "#F5F4EC"
  surfaceContainerLowest: appPalette.neutral[100],
  surfaceBright: appPalette.neutral["98"],
  surfaceDim: appPalette.neutral[80], // was "#DBDAD3"

  backdrop: appPalette.neutral[0],
  relation: { organization: "#0B79D0", person: "#C77700", tag: "#C51162" },
  planning: {
    // planningRowBackground: "#F4F5F4",
  },
  timesheet: {
    orange: "rgba(237, 108, 2, 1)",
    green: "rgba(123, 198, 126, 1)",
  },
  importance: {
    major: { fg: "#d82e18", bg: "#f2bdb4" },
    medium: { fg: "#db7c2e", bg: "#EAAF71" },
    normal: { fg: "#6b6f73", bg: "#edf1f4" },
    low: { fg: "#01a2fa", bg: "#c6e9ff" },
  },
};

export const colors: CustomPalette = {
  appColors,
  appPalette,
  palette: {
    // type: "light",
    background: {
      default: "#FFF",
      paper: appColors.surfaceContainerLow,
    },
    primary: {
      light: appColors.primary,
      main: appPalette.primary[60],
      dark: appColors.primary,
      contrastText: appColors.onPrimary,
    },
    secondary: {
      light: appColors.secondary,
      main: appPalette.secondary[60],
      dark: appColors.secondary,
      contrastText: appColors.onSecondary,
    },
  },
};
